<!--系统新手提示-->
<template>
  <div
    class="ivu-tooltip-popper ivu-tooltip-dark system-tip"
    v-show="showTip"
    :x-placement="placement"
  >
    <div class="ivu-tooltip-content">
      <div class="ivu-tooltip-arrow"></div>
      <div class="ivu-tooltip-inner ivu-tooltip-inner-with-width">
        <div class="tip-system">
          {{ this.content }}<br />
          <span class="i-know" @click="closeTip">{{ $t('common.iknow') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const idSubFfix = 'SystemTip'; //定义后缀
export default {
  props: {
    tipId: {
      require: true,
      type: [String, Number],
    },
    content: {
      type: String,
    },
    placement: {
      type: String,
      default: 'left-start',
    },
  },
  data() {
    return {
      showTip: false,
    };
  },
  computed: {
    id() {
      return `${this.tipId}-${idSubFfix}`;
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.getTipStatus();
  },
  methods: {
    getTipStatus() {
      //检查当前tip的查看状态，如果点过我知道了就再也不显示
      if (localStorage.getItem(this.id)) {
        this.showTip = false;
      } else {
        this.showTip = true;
      }
    },
    closeTip() {
      this.showTip = false;
      localStorage.setItem(this.id, true);
    },
  },
};
</script>
<style lang="scss" type="text/scss">
.system-tip {
  position: absolute;
  height: 100px;
  .tip-system {
    white-space: pre-line;
    font-size: 14px;
  }
  .i-know {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
    cursor: pointer;
    font-size: 13px;
    color: $secondary-color;
    &:hover {
      color: $secondary-color-hover;
    }
  }
}
.ivu-tooltip-popper {
  z-index: 9999 !important;
}
</style>
